<template>
    <div>
        <SOModalExport
            :is-running="isExporting"
            :context="''"
            :sub-context="subContext"
            :total-data="`${totalPembayaranEdc} Pembayaran`"
            :export-data-exist="data.length > 0 ? data.filter((v) => v.downloaded === false).length : 0"
            @close="closeModal"
            @do-export="doExport"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOModalExport from "@/so-components/global/modal/SOModalExport";

import { moduleName } from "../store/state";

export default {
    name: "ModalExportListPembayaranEDC",
    components: {
        SOModalExport,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {});
    },
    computed: {
        ...mapGetters(moduleName, {
            exportData: "exportData",
            detailSettlementEdc: "detailSettlementEdc",
        }),
        totalPembayaranEdc() {
            return this.detailSettlementEdc.pembayaran_edc.length;
        },
        isExporting() {
            return this.exportData.exporting;
        },
        data() {
            return this.exportData.data;
        },
        subContext() {
            return `Data mulai 20 Jan 2020 s/d 20 Feb 2020`;
        },
    },
    methods: {
        ...mapActions({
            toggleExporting: `${moduleName}/toggleExporting`,
            doExportData: `${moduleName}/exportListPembayaranEdc`,
        }),
        closeModal() {
            this.$router.go(-1);
        },
        async doExport() {
            await this.closeModal();
            await this.toggleExporting(true);
            await this.doExportData({
                idsettlement: this.$route.params.id_settlement,
                idoutlet: this.detailSettlementEdc.detail_data.idoutlet,
            });
        },
    },
};
</script>
